import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { SessionGroup } from '../../types/server-types';
import { CacheKeys } from './cache-configuration';
import { http } from '../http';

export const useGetSessionGroup = (
  id: string,
): UseQueryResult<SessionGroup> => {
  return useQuery({
    queryKey: [CacheKeys.SESSION_GROUP, id],
    queryFn: () => http.getSessionGroup(id),
    refetchInterval: 5000,
  });
};
